import { ResponsiveService } from './../../../../../../core/services/responsive.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { DocumentTypeService } from '../../../../../../core/services/document-type.service';
import { UserService } from '../../../../../../core/services/user.service';
import { DocumentService } from '../../../../../../core/services/document.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../../../core/services/notification.service';
import { CommonService } from '../../../../../../core/services/common.service';
import { Message } from '../../../../../../core/class/message';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { BranchService } from 'src/app/core/services/branch.service';
import { MatSort, Sort } from '@angular/material/sort';
import { FormControl, NgForm } from '@angular/forms';
import { MatCheckboxChange, MatMenu, MatMenuTrigger, MatSelect } from '@angular/material';
import { BehaviorSubject, merge, Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { CdkDetailRowDirective } from 'src/app/shared/directive/cdk-detail-row.directive';
import { takeUntil, tap } from 'rxjs/operators';
import { WarningComponent } from '../../../../../../shared/components/warning/warning.component';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BaseComponent } from '../../../../../../shared/components/base/base.component';
import { EnumColumnTable, EnumContractStatus, EnumContractUserRole, EnumLinkSignStatus } from 'src/app/core/constants/contract';
import { WarningSmsContractService } from 'src/app/core/services/warning-sms-contract.service';
import { ErrorCode } from '../../../../../../core/constants/error-code';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { ForwardContractDialogComponent } from '../forward-contract-dialog/forward-contract-dialog.component';
import { MultiDownloadService } from '../../../../../../core/services/multi-download.service';
import { EnumDownloadMenuName } from '../../../../../../core/constants/common';
import { SignContractNotifyComponent } from '../search-document-mine/sign-contract-notify/sign-contract-notify.component';
import { ResendContractDialogComponent } from '../resend-contract-dialog/resend-contract-dialog.component';
import { SignContractLotNotifyComponent } from './sign-contract-lot-notify/sign-contract-lot-notify.component';

@Component({
  selector: 'app-search-document-processing',
  templateUrl: './search-document-processing.component.html',
  styleUrls: ['./search-document-processing.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SearchDocumentProcessingComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  maxDate = new Date()
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isDisableNamePhoneEmail = true;
  public cecaEnable: boolean;
  entType: any = localStorage.getItem('entType');
  selection = new SelectionModel<string>(true, []);
  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: 'select', default: true, showXS: true, showSM: true, showMD: true, name: '', check: true },
    { def: 'STT', default: true, showXS: true, showSM: true, showMD: true, name: '', check: true },
    { def: 'contractCode', default: true, showXS: true, showSM: true, showMD: true, name: '', check: true },
    { def: 'serviceType', default: true, showXS: true, showSM: true, showMD: true, name: 'form.service_type', check: true },
    { def: 'contractName', default: true, showXS: false, showSM: false, showMD: true, name: 'headertable.contract_parties', check: true },
    { def: 'userName', default: true, showXS: false, showSM: false, showMD: true, name: 'headertable.contract_parties_email', check: true },
    { def: 'phone', default: true, showXS: false, showSM: false, showMD: true, name: 'headertable.phone', check: false },
    { def: 'email', default: true, showXS: false, showSM: false, showMD: true, name: 'search_form.performerEmail', check: true },
    { def: 'linkSignStatus', default: true, showXS: false, showSM: false, showMD: true, name: 'searchDocumentMine.lbl_link_sign_status', check: false },
    { def: 'linkExpiredDate', default: true, showXS: false, showSM: false, showMD: true, name: 'searchDocumentMine.lbl_link_expired_date', check: false },
    { def: 'receivedAt', default: false, showXS: false, showSM: false, showMD: true, name: 'search_form.dateRequest', check: false },
    { def: 'contractStatus', default: true, showXS: false, showSM: false, showMD: true, name: 'search_form.processing_progress', check: false },
    { def: 'status', default: true, showXS: false, showSM: false, showMD: true, name: 'form.status_process', check: true },
    { def: 'numberOtpConfig', default: true, showXS: false, showSM: false, showMD: true, name: 'search_form.number_SMS_OTP_configured', check: false },
    { def: 'numberOtpUsed', default: true, showXS: false, showSM: false, showMD: true, name: 'search_form.number_SMS_OTP_used', check: false },
    { def: 'numberOtpRemain', default: true, showXS: false, showSM: true, showMD: true, name: 'search_form.number_SMS_OTP_remaining', check: false },
    { def: 'action', default: true, showXS: true, showSM: true, showMD: true, name: '', check: true }
  ];
  tableWidth = 950;
  isCheckedAllColumn: boolean = false;
  showColumnSelection = false;
  selectedColumn: string;
  enumContractStatus = EnumContractStatus;
  linkSignStatusEnum = EnumLinkSignStatus;
  isNotAttestedUser: boolean = false;

  documents = new Document();
  enumContractUserRole = EnumContractUserRole;
  enumColumnTable = EnumColumnTable;
  checkFocus = true;
  dataSource: DocumentDataSource;
  childDataSourceList: DocumentTypeDataSourceKeyPair = {};
  paginate: Paginate;
  oldData = this.documents;
  isFirstLoad = true;
  isTableLoading = false;
  dataSelected: Document[] = []
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('myForm', { static: false }) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;
  @ViewChild('serviceTypeSelect', { static: false }) serviceTypeSelect: MatSelect;
  sortDirection = 'ASC';
  sortColumn = 'name';
  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];
  isDocumentManager: boolean;
  enterpriseId: string;
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };
  // List all parent branches
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  serviceTypesFilterCtrl: FormControl = new FormControl();
  // List all parent branches
  // parentBranches: { id: string, name: '' }[];
  isBasicSearchForm = true;
  createdDateErr = '';
  finishedDateErr = '';
  @Input() singleChildRowDetail: boolean;
  private EventWarningContractSubscription: Subscription;
  private dialogRef: any;
  private onDestroySubject = new Subject<void>();
  serviceTypes: any[];
  isServiceTypesLoading = false;
  private onDestroy = new Subject<void>();
  constructor(
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private branchService: BranchService,
    private changeDetectorRefs: ChangeDetectorRef,
    private warningSmsContractService: WarningSmsContractService,
    private responsiveService: ResponsiveService,
    private downloadService: MultiDownloadService,
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  ngOnInit() {
    // this.getColumnByUser();
    this.isDocumentManager = true;
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';
    this.dataSource = new DocumentDataSource();
    this.loadData();
    this.notificationService.subscribeErrorService();
    // reset errorCode
    this.notificationService.resetErrorCode();
    // subscribe errorCode
    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.toastr.error(this.message.getMessage('messages.contract_processed'));
        this.loadData();
      }
      if (errorCode === ErrorCode.ContractProcessed) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.loadData();
      }
    });

    window.scrollTo(0, 0);
    // this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    // this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
    //   (result) => {
    //     this.warningContractQuantity = result;
    //   }
    // );
    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this.onDestroySubject))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });
    this.getServiceTypeByEnterprise();
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.isServiceTypesLoading = true;
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      this.isServiceTypesLoading = false;
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.filteredServiceTypes.next(rs.data.slice());
        this.documents.serviceType = this.documents.serviceType ? Number(this.documents.serviceType) : null;
      }
    }, () => this.isServiceTypesLoading = false);
  }

  onSearch(page: number = 0, pageSize: number = 10) {
    this.onFilterData(page, pageSize);
  }

  getColumnByUser() {
    // this.documentService.getColumnDynamic("CREATE_MY_RECEIVE_DOCUMENT").subscribe(rs => {
    //   if (rs.success) {
    //     if (rs.data) {
    //       const check = JSON.parse(rs.data);
    //       const recordsWithDefaultTrue = check.find(item => item.default === false);
    //       if (recordsWithDefaultTrue) {
    //         this.isCheckedAllColumn = false;
    //       } else {
    //         this.isCheckedAllColumn = true;
    //       }
    //       this.columnDefinitions = this.columnDefinitions.map(ele => {
    //         const checkDef = check.find(item => item.def === ele.def);
    //         return checkDef ? {...ele, default: checkDef.default} : ele;
    //       });
    //     }
    //   } else {
    //     this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'));
    //   }
    //   this.getDisplayedColumns();
    //   this.changeWidthTable();
    // });
  }

  onCheckboxChange(column: any) {
    const recordsWithDefaultTrue = this.columnDefinitions.find(item => item.default === false);
    if (recordsWithDefaultTrue) {
      this.isCheckedAllColumn = false;
    } else {
      this.isCheckedAllColumn = true;
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    // const codeColumnByUser = {
    //   code: "CREATE_MY_RECEIVE_DOCUMENT",
    //   value: JSON.stringify(this.columnDefinitions.map(item => ({
    //     def: item.def,
    //     default: item.default
    //   })))
    // };
    // this.documentService.saveColumnDynamic(codeColumnByUser)
    //   .subscribe(res => {
    //   });
  }

  onAllColumnCheckboxChange(isCheck: any) {
    if (isCheck) {
      this.columnDefinitions.forEach((column) => {
        column.default = true;
      });
    } else {
      this.columnDefinitions.forEach((column) => {
        if (!column.check) {
          column.default = false;
        }
      });
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    // const codeColumnByUser = {
    //   code: "CREATE_MY_RECEIVE_DOCUMENT",
    //   value: JSON.stringify(this.columnDefinitions.map(item => ({
    //     def: item.def,
    //     default: item.default
    //   })))
    // };
    // this.documentService.saveColumnDynamic(codeColumnByUser)
    //   .subscribe(res => {
    //   });
  }

  changeWidthTable() {
    const check = this.columnDefinitions.filter(item => item.default === true);
    if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
      this.tableWidth = 1650;
    } else {
      if (check.length > 9) {
        this.tableWidth = 1650;
      } else if (check.length <= 9) {
        this.tableWidth = 950;
      }
    }
  }


  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
      this.tableWidth = 300;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD && cd.default)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.filter(cd => cd.default).map(cd => cd.def);
      }
      this.changeWidthTable();
    }
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    // this.EventWarningContractSubscription.unsubscribe();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }

  getFilterCondition(page: number, pageSize: number, data: any): any {
    const {
      contractCode,
      contractName,
      userName,
      phone,
      serviceType,
      email,
      receivedAt,
      status,
      linkSignStatus
    } = data;
    let filterCondition: any = {
      contractCode,
      userName: userName,
      serviceType,
      phone,
      email,
      status: status,
      linkSignStatus: linkSignStatus || null,
      page,
      pageSize,
    };


    if (!this.isBasicSearchForm) {
      filterCondition = {
        ...filterCondition,
        receivedAt,
        contractName,
      };
    }

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    // let column = null;
    // switch (sortColumn) {
    //   case 'contractName':
    //     column = {
    //       contractName: sortDirection
    //     };
    //     break;
    //   case 'receivedTime':
    //     column = {
    //       receivedTime: sortDirection
    //     };
    //     break;
    // }

    filterCondition.sorts = null;

    // console.log("filterCondition", filterCondition);
    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {


    // if (this.parentBranches) {
    //   this.selectedBranch = this.parentBranches.find(x => {
    //     return x.id === paramEnterprise;
    //   });
    // }

    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    this.isTableLoading = true;
    this.dataSource.setData([]);
    this.documentService.searchProcessingDocument(this.getFilterCondition(page, pageSize, this.documents))
      .subscribe(rs => {
        this.isTableLoading = false;
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }

        if (rs.data && rs.data.dataRow != null) {
          this.initParent(rs);
        }
      }, () => this.isTableLoading = false);
  }

  /**
   * Get inform of branch
   */
  getBranch(branchId: number) {
    this.branchService.getBranch(branchId).subscribe(
      rs => {
        this.selectedBranch = {
          id: String(branchId),
          name: rs.data.name
        };
      }
    );
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;

    this.parentDocuments = rs.data.dataRow;
    rs.data.dataRow.forEach(el => {
      el.STT = stt++;
    });
    this.dataSource.setData(this.parentDocuments);
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {
    this.oldData = { ...this.documents };
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
    // set null for document model


    this.isTableLoading = true;
    this.dataSource.setData([]);
    this.documentService.searchProcessingDocument(this.getFilterCondition(page, pageSize, this.oldData))
      .subscribe(
        rs => {
          this.isTableLoading = false;
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          this.initParent(rs);
        }
        , () => this.isTableLoading = false
      );
  }

  /**
   * Delete document
   * xóa
   */

  /**
   * Chuyển tiếp HĐ
   * Forward Contract
   */

  forwardContract(element) {
    const customerId = this.decodeId(element.customerId)
    const payload = {
      id: customerId,
      isCreatedSide: false,
      contractUserId: null
    };
    this.documentService.retrieveSignLink(element.id, payload).subscribe(res => {
      if (res.data) {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(res.data).then(() => {
            this.toastr.success(
              this.message.getMessage("app_mobile.link_copied")
            );
          }).catch((error) => {
            console.error('Lỗi khi sao chép đường dẫn:', error);
            this.unsecuredCopyToClipboard(res.data);
          });
        } else {
          this.unsecuredCopyToClipboard(res.data);
        }
      }
    })
  }

  sendLinkContract(id: string, document) {
    const documentNew = {
      ...document,
      name: document.contractName
    }
    this.documentService.getCustomerProcessing(id).subscribe(async rs => {
      if (rs.success && rs.data.length > 0) {
        // console.log('rs success =true', rs)
        this.dialogRef = this.dialog.open(ResendContractDialogComponent, {
          width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
          maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
          data: {
            contractId: id,
            document: documentNew,
            dataSource: rs.data,
            width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
            maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw'
          }
        });
        this.dialogRef.afterClosed().subscribe(rs => {
          if (rs) {
            this.toastr.success(this.message.getMessage('messages.send_link_contract_user_success'));
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          }
        });
      } else {
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        if (rs.success && rs.data && rs.data.length == 0) {
          this.toastr.error(this.message.getMessage('messages.none_customer'));
        } else {
          this.toastr.error(rs.message);
        }
      }
    }, err => {
      this.toastr.error(this.message.getMessage('messages.send_link_contract_user_error'));
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
    });
  }

  /**
   * Navigate to view detail document
   */
  notifySignContract(element) {
    this.documentService.getAllUserProcessById(element.id).subscribe(res => {
      if (res.success && res.data.length > 0) {
        const dialogRe = this.dialog.open(SignContractNotifyComponent, {
          width: '700px',
          data: { data: element, listUser: res.data },
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
          }
        });
      } else {
        this.toastr.error(this.message.getMessage('messages.action_notify_sign_contract_error'));
        this.router.navigate(['/home-enterprise/search-my-created-document']);
      }
    }, err => {
      this.toastr.error(this.message.getMessage('messages.action_notify_sign_contract_error'));
    });
  }
  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(documentData: any) {
    if (documentData.id && documentData.customerId) {
      this.documentService.undoOtpCustomer(documentData.customerId, documentData.id).subscribe(res => {
        if (res.success) {
          this.toastr.success(this.message.getMessage('messages.undo_otp_success'))
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        } else {
          this.toastr.error(res.message)
        }
      });
    }
  }


  multiDownload() {

  }

  allowOnlyNumbersAndSpace(event: KeyboardEvent): void {
    const allowedRegex = /^[0-9 ]$/;
    const key = event.key;

    if (!allowedRegex.test(key)) {
      event.preventDefault();
    }
  }

  getOTP(element: any, number: any) {
    if (!element.enableResetOtp) {
      return this.message.getMessage('search_form.no_use')
    } else if (element.enableResetOtp && !element.isLimitOtp) {
      return this.message.getMessage('search_form.unlimited')
    } else {
      return number
    }
  }

  onClickBtnFilter() {
    if (this.columnDefinitions.length > 15) {
      const action = this.columnDefinitions.pop();
      this.columnDefinitions.pop();
      this.columnDefinitions.pop();
      this.columnDefinitions.push(action);
      this.getDisplayedColumns();
    }
    this.onFilterData(0, this.paginate.pageSize);
  }


  /**
   * Open advanced search form
   */
  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Close advanced search form
   */
  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Set params for to navigate
   */

  /**
   * selected equal data length in page to checkbox all is selected
   */
  isAllSelected() {
    const selecteds = this.selection.selected;
    const dataSourceIds = this.dataSource.data.value.map(d => d.idNotify);
    const intersectionArr = dataSourceIds.filter(data => selecteds.includes(data));
    return intersectionArr.length === dataSourceIds.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    const dataSourceIds = this.dataSource.data.value.map(ds => ds.idNotify);
    this.dataSource.data.value.forEach(item => {
      this.addListRecord(!this.isAllSelected(), item)
    })
    this.isAllSelected() ?
      this.selection.deselect(...dataSourceIds) :
      this.selection.select(...dataSourceIds);
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  unsecuredCopyToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      // debugger
      const res = document.execCommand('copy');
      if (res) {
        this.toastr.success(
          this.message.getMessage("app_mobile.link_copied")
        );
      } else {
        console.error('Không copy được');
      }

    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  notifyLot() {
    const data = this.dataSelected.filter(item => this.selection.selected.includes(item.idNotify)).map(item => {
      delete item['isSendSms']
      return item
    })
    console.log(data);
    const dialogRef = this.dialog.open(SignContractLotNotifyComponent, {
      width: '1000px',
      data: data
    })
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
        this.dataSelected = []
        this.selection.clear()
      }
    });
  }
  addListRecord(event: boolean, element: Document){
    if(event){
      if(!this.checkExisted(element)){
        this.dataSelected.push(element)
      }
    } else {
      this.dataSelected = this.dataSelected.filter(item => item.idNotify !== element.idNotify)
    }
  }

  checkExisted(data:Document){
    return this.dataSelected.filter(item => item.idNotify == data.idNotify).length > 0
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class Document {
  id: string;
  contractCode: string;
  contractName: string;
  userName: string;
  phone: string;
  status: any;
  receivedAt: any;
  email: string;
  serviceType: any;
  idNotify: string;
  linkSignStatus: any;
  linkExpiredDate: any;

  //   signRole: any;
  //   nameOrEmailOrPhoneUserSign: string;
  //   senderName: string;
}

export class DocumentTypeDataSourceKeyPair {
  [key: string]: DocumentDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}
